module.exports = __webpack_public_path__ + "static/img/company1.9dc2c59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/company1.png
// module id = 9FQk
// module chunks = 0